import React from "react";
import "./Ourteam.css";

export default function Ourteam() {
  return (
    <section className="cis-team" id="team" aria-labelledby="team-title">
      <div className="cis-team__container">
        <div className="cis-team__topGrid">
          <div className="cis-team__imageWrap">
            <div className="cis-team__imageContainer">
              <img
                className="cis-team__image"
                src="/cm-about.jpg"
                alt="Nelson Rascon, Founder - Community Impact Solutions"
                loading="lazy"
              />
            </div>
            <div className="cis-team__imageAccent" aria-hidden="true"></div>
          </div>

          <div className="cis-team__introContent">
            <div className="cis-team__titleWrapper">
              <h3 className="cis-team__name">Nelson Rascon</h3>
            </div>

            <p className="cis-team__paragraph">
              Nelson Rascon is a highly respected consultant, trainer, and
              community leader with nearly 20 years of experience in fatherhood
              engagement, family support programming, and nonprofit
              development. With a deep commitment to strengthening families and
              supporting fathers, Nelson brings a powerful combination of lived
              experience, professional training, and leadership expertise to
              every project he takes on.
            </p>

            <p className="cis-team__paragraph">
              Nelson is certified through the Washington Health Care
              Authority&apos;s Peer Support Program, which trains individuals
              with lived experience in behavioral health recovery to become
              Certified Peer Support Specialists. The program focuses on
              supporting people facing mental health and substance use
              challenges.
              <a
                href="https://www.hca.wa.gov/billers-providers-partners/program-information-providers/peer-support"
                className="cis-team__inline-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}Learn more about the Peer Support Program →
              </a>
            </p>
          </div>
        </div>

        <div className="cis-team__bottomContent">
          <div className="cis-team__divider"></div>

          <p className="cis-team__paragraph">
            A Certified Peer since 2010 and one of Washington State&apos;s
            first male Parent Partners, Nelson has been a statewide leader in
            advancing father-focused services and improving behavioral health
            outcomes for families. As the former Director and founder of Dads
            MOVE, he played a key role in building and growing the organization
            into a successful statewide nonprofit, expanding its reach,
            developing impactful programs, and cultivating strong community
            partnerships.
          </p>

          <p className="cis-team__paragraph">
            Nelson&apos;s dedication to this work is rooted in lived experience.
            He gained sole custody of his son when his son was three years old
            and has also raised two special-needs step-children, giving him a
            deeply personal understanding of the challenges and strengths within
            families navigating behavioral health, developmental, and
            educational systems. These experiences have shaped his passion for
            empowering fathers and supporting caregivers who often feel
            overlooked or underserved.
          </p>

          <p className="cis-team__paragraph">
            Over his career, Nelson has trained providers, guided organizations
            in developing fatherhood initiatives, and helped shape policies and
            programs designed to uplift families and communities. Today, he
            brings his expertise in fatherhood programming, nonprofit growth,
            peer support, leadership development, and community engagement to
            organizations seeking to build stronger, more inclusive, and more
            effective services for fathers and families.
          </p>

          <p className="cis-team__paragraph">
            Besides Community Impact Solutions, Nelson is also on the board of
            On The Road With PartnerCafe, a nonprofit serving families in our
            communities and connecting them with needed resources. Nelson
            directly leads The Center for Fatherhood Advancement., where they are
            specifically focused on supporting fathers with coaching, practical
            resources, peer connection, and guidance.
          </p>

          <div className="cis-team__linkBlock">
            <p className="cis-team__paragraph cis-team__paragraph--link">
              <span className="cis-team__linkLabel">
                Learn more about The Center for Fatherhood Advancement.
              </span>
              <a
                href="https://ontheroadwpc.org/the-center-for-fatherhood-advancement/"
                className="cis-team__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                ontheroadwpc.org/the-fatherhood-alliance/
                <svg
                  className="cis-team__linkIcon"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 17L17 7M17 7H7M17 7V17"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}